function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 18C5.59375 18 2 14.4062 2 10C2 5.59375 5.59375 2 10 2C14.4062 2 18 5.59375 18 10C18 14.4062 14.4062 18 10 18ZM9 7C9 7.5625 9.4375 8 10 8C10.5625 8 11 7.5625 11 7C11 6.4375 10.5625 6 10 6C9.4375 6 9 6.4375 9 7ZM8.75 9C8.34375 9 8 9.34375 8 9.75C8 10.1562 8.34375 10.5 8.75 10.5H9.5V12.5H8.75C8.34375 12.5 8 12.8438 8 13.25C8 13.6562 8.34375 14 8.75 14H11.25C11.6562 14 12 13.6562 12 13.25C12 12.8438 11.6562 12.5 11.25 12.5H11V9.75C11 9.34375 10.6562 9 10.25 9H8.75Z",
  fill: "#006CA3"
});

function SvgCampaignInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignInfo);
export default __webpack_public_path__ + "static/media/campaign-info.96330c65.svg";
export { ForwardRef as ReactComponent };